
import apolloClient  from './utitl'
import gql from 'graphql-tag'

// 查询所有每日报表日志
function getAllFlowDailyReport(params){
  return apolloClient.query({
    fetchPolicy:'no-cache',
		query: gql`query getAllFlowDailyReport ($pid:String!,$bd: String,$ed:String,$lt:[Int],$ls:[Int]) {
     findAllYcbAccDailyStatement
      (beginTime: $bd, # 可选 起始时间，格式为yyyy-MM-dd HH:mm:ss，时分秒可选
       endTime: $ed, #可选 截止时间，格式同上
       lstType: $lt, #可选 交易类型 (int数组)
       lstState: $ls#可选 状态 (int数组)
      )
      {
        date # 日期 yyyy-MM-dd
        inCount #int 收入笔数
        inAmount #long 收入金额
        outCount #int 支出笔数
        outAmount #long 支出金额
      }
      findAllWeChatAccDailyStatement
      (partnerId: $pid, #必填！商户id
       beginTime: $bd, # 可选 起始时间，格式为yyyy-MM-dd HH:mm:ss，时分秒可选
       endTime: $ed, #可选 截止时间，格式同上
       lstType: $lt, #可选 交易类型 (int数组)
       lstState: $ls) #可选 状态 (int数组)

      {
        date # 日期 yyyy-MM-dd

        inCount #int 收入笔数
        inAmount #long 收入金额

        outCount #int 支出笔数
        outAmount #long 支出金额
      }
      findPointsDailyStatement
      (#userId: $openid, #必填！ 用户账号
       partnerId: $pid, #可选 商户id
       beginTime: $bd, # 可选 起始时间，格式为yyyy-MM-dd HH:mm:ss，时分秒可选
       endTime: $ed, #可选 截止时间，格式同上
       lstType: $lt, #可选 交易类型 (int数组)
       lstState: $ls) #可选 状态 (int数组)

      {
        date # 日期 yyyy-MM-dd

        inCount #int 收入笔数
        inAmount #long 收入金额

        outCount #int 支出笔数
        outAmount #long 支出金额
      }
    }`,
		variables: params
	})
}

// 添加一个网点
function addPos(params){
  return apolloClient.mutate({
    mutation:gql`mutation addOnePos($posJsonStr:String!){
      addOnePos(posJsonStr:$posJsonStr){
        posId
        partnerId
        name
        picture
      }
    }
    `,
    variables:params
  })
}

// 获取当前商户链点流水记录
function getAssetBalance(params){
  return apolloClient.query({
    fetchPolicy:'no-cache',
		query: gql`query getAssetBalance ($pid:String!,$bd: String,$ed:String,$lt:[Int],$ls:[Int],$ld:[Int]) {
     findPartnerPointsInfo
      (partnerId: $pid, #必填！ 商户id
       beginTime: $bd, #可选 起始时间，格式为yyyy-MM-dd HH:mm:ss，时分秒可选
       endTime: $ed, #可选 截止时间，格式同上
       lstDirection: $ld, #[0,1], #可选 交易方向 (int数组)
       lstType: $lt , #[1,2,3,4], #可选 交易类型 (int数组)
       lstState: $ls, #[1,2], #可选 状态 (int数组)
       page: 1,
       size: 1000) #可选 分页参数(不填则查询全部))

      {
        points {
          id
          userAccount # 用户id
          type #int 账号类型，0：借记；1：贷记
          points #long 链点数量
          remark
          version #int 版本号
          sign # 签名
          createTime
          modifyTime
          state #int
        }

        lstPointsRecord {
          id
          userAccount # 用户id
          opponentAccount # 交易对方账号
          vNo # 流水号
          direction #int 链点流动方向，0：收入；1：支出
          type #int 交易类型
          changeNum #long 变动数量
          createTime # 变动时间
          pointsAfter #long 变动后链点数量
          pointsBefore #long 变动前链点数量
          remark
          sign # 签名
          state #int
        }
      }
      findPartnerBalanceInfo
      (partnerId: $pid, #必填！ 商户id
       beginTime: $bd, #可选 起始时间，格式为yyyy-MM-dd HH:mm:ss，时分秒可选
       endTime: $ed, #可选 截止时间，格式同上
       lstDirection: $ld, #可选 交易方向 (int数组)
       lstType: $lt, #可选 交易类型 (int数组)
       lstState: $ls, #可选 状态 (int数组)
       page: 1,
       size: 1000) #可选 分页参数(不填则查询全部))

      {
        balance {
          id
          userId # 用户账号(openId)
          type #int 账号类型，0：借记；1：贷记
          balance #long 链点数量
          remark
          version #int 版本号
          sign # 签名
          createTime
          modifyTime
          state #int
        }

        lstBalanceDetail {
          id
          userId # 用户账号(openId)
          opponent # 交易对方账号
          vNo # 流水号
          direction #int 链点流动方向，0：支出；1：收入
          type #int 交易类型
          amount #long 变动数量
          createTime # 变动时间
          balanceAfter #long 变动后链点数量
          balanceBefore #long 变动前链点数量
          remark
          sign # 签名
          state #int
        }
      }
    }`,
		variables: params
	})
}

// 获取当前商户链点流水记录，（为什么相同的接口写了两遍）
function getPoints(params){
  return apolloClient.query({
    fetchPolicy:'no-cache',
		query: gql`query getPoints ($pid:String!,$bd: String,$ed:String,$lt:[Int],$ls:[Int],$ld:[Int]) {
     findPartnerPointsInfo
      (partnerId: $pid, #必填！ 商户id
       beginTime: $bd, #可选 起始时间，格式为yyyy-MM-dd HH:mm:ss，时分秒可选
       endTime: $ed, #可选 截止时间，格式同上
       lstDirection: $ld, #[0,1], #可选 交易方向 (int数组)
       lstType: $lt , #[1,2,3,4], #可选 交易类型 (int数组)
       lstState: $ls, #[1,2], #可选 状态 (int数组)
       page: 1,
       size: 1000) #可选 分页参数(不填则查询全部))

      {
        points {
          id
          userAccount # 用户id
          type #int 账号类型，0：借记；1：贷记
          points #long 链点数量
          remark
          version #int 版本号
          sign # 签名
          createTime
          modifyTime
          state #int
        }
      }
    }`,
		variables: params
	})
}

// 查询商家提现记录
function getWithDrawRecords(params){
  return apolloClient.query({
    fetchPolicy:'no-cache',
		query: gql`query getWithDrawRecords ($acc:String,$state:Int,$bd: String,$ed:String) {
     findAllWithdraw
    # 参数
      (
        accountType: 0, # 账号类型 (int);  0:商家 | 1:个人账号
        withdrawAccount: $acc, # 发起提现的账号
        withdrawState: $state,
        beginModifyTime: $bd,
        endModifyTime: $ed
        page: 1,
        size: 20
      )

    # 返回字段
      {
        id
        withdrawId  # 提现单号
        accountType # 账号类型 (int) (0.商家; 1.个人账号)
        withdrawAccount # 发起提现的账号
        operator    # 发起提现的用户ID
        withdrawAmount # 提现金额 (int)
        fee         # 费用 (int)
        withdrawState # 状态 (int) (0.发起; 1.打款完成)
        bankId      # 提现银行卡号
        bankName    # 银行名称
        bankCode    # 银行编码
        bankBranch  # 支行名称
        cityCode    # 所在城市编码
        cityName    # 所在城市名称
        accountName # 户名
        isPublic    # 对公标记 (int) (0.银行卡为对私; 1.对公)
        createTime
        modifyTime
      }
    }`,
		variables: params
	})
}

// 查询退款记录
function geRefundRecords(params){
  return apolloClient.query({
    fetchPolicy:'no-cache',
		query: gql`query geRefundRecords ($acc:String,$pid:String,$op:String,$type:Int,$state:Int,$bd: String,$ed:String) {
      # 方法名
        queryRefundApply
      # 参数
        (
          refundApplyDTO: { # 所有内部字段都为可选
            userAccount: $acc, # 退款的用户账号 #
            partnerId: $pid, # 退款余额账号所属商户
            operator: $op, # 操作退款的管理员账号
            amountType: $type,  # 退款资金类型
            applyState: $state,  # 退款状态
            beginModifyTime: $bd, # 最后变更时间_起始
            endModifyTime: $ed,   # 最后变更时间_截止
            page: 1,
            size: 20
          }
        )

      # 返回字段
        {
          id
          refundApplyId # 退款申请单编号
          userAccount   # 退款的用户账号
          partnerId     # 退款余额账号所属商户
          operator      # 操作退款的管理员账号
          amountType    # 退款资金类型 (int) (0.链点; 1.余额)
          applyState    # 退款状态 (int) (-1.驳回申请; 0.申请中; 1.完成退款)
          zhmRefundAmount # 众敏系统退款金额 (int)
          ycbRefundAmount # 有车邦老系统退款金额 (int)
          expectRefundAmount # 期望退款金额 (int)
          desc # 退款备注
          modifyTime
          createTime
        }

    }`,
		variables: params
	})
}

// 查询发票记录
function getInvoiceRecords(params){
  return apolloClient.query({
    fetchPolicy:'no-cache',
		query: gql`query getInvoiceRecords ($acc:String,$pid:String,$state:Int!) {
    # 方法名
      findInvoiceOrder
    # 参数
      (
        invoiceFlag: $state, # 发票标识(int) (必填) (0.未开发票; 1.已申请开发票; 2.已开票)
        userAccount: $acc, # 用户账号 (可选, 若填写，则视为用户自查, 优先级高于partnerId)
        partnerId: $pid, # 商户编号 (可选, 若填写, 则视为商户自查; 若未填写, 则视为众敏查所有)
        page: 1,
        size: 20
      )

    # 返回字段
      {
        id
        orderId      # 订单编号
        partnerId    # 合作商户编号
        posId        # 下单网点编号
        orderPosName # 下单网点名称
        userAccount  # 用户账号
        plateNum     # 车牌号
        balancePay   # 余额支付金额 (int)
        pointsPay    # 链点支付金额 (int)
        couponId     # 洗车券编号
        couponPay    # 洗车券支付金额 (int)
        cashCouponId # 代金券编号
        cashCouponPay# 代金券支付金额 (int)
        amount       # 现金支付金额 (int)
        payMethod    # 现金支付方式 (int) (1.微信；2.支付宝)
        completeState# 订单完成状态 (int) (1.未支付; 2.已支付,待发货; 3.已发货,完成; 4.超时未发货,已经退款;)
        orderTime    # 下单时间
        servicePosName # 实际服务网点名称
        completeTime # 服务受理时间
        agentRewardState # 推广奖励发放状态 (int) (0.未发放; 1.已发放)
        agentId # 代理人编号
        sign    # 签名
        refundAmount # 退款金额 (int)
        refundTimes  # 退款次数 (int)
        balancePartnerId # 余额所属商户编号
        invoiceFlag  # 是否开发票 (int) (0.未开发票; 1.申请中; 2.已开票)
        orderIdOfWepay # 微信支付交易单号
        freezeFlag #int 0：取消冻结；1：冻结
        remark
        createTime
        modifyTime
        state #int
      }
    }`,
		variables: params
	})
}

// 查询发票抬头信息
function getInvoiceOfUser(params){
  return apolloClient.query({
    fetchPolicy:'no-cache',
		query: gql`query getInvoiceOfUser ($acc:String!) {
    # 方法名
      findInvoiceInfoByUserAccountAndState
    # 参数
      (userAccount: $acc) # 用户账号 (必填)
    # 返回字段
      {
        id
        userAccount # 用户账号
        title       # 发票抬头
        taxNumber   # 税号
        address     # 公司地址
        telephone   # 电话
        bankName    # 开户银行
        bankAccount # 银行账号
        type        # 发票类型 (int) (0.普票；1.专票)
        email       # 接收发票邮箱
        createTime  # 创建时间
        modifyTime  # 修改时间
        state       # 数据状态 (int)
      }
    }`,
		variables: params
	})
}

// 根据服务商id查询所有网点
function getPosListByPartnerId(params){
  return apolloClient.query({
    fetchPolicy: 'no-cache',
    query: gql`query getPosList ($partnerId: String!, $page: Int!, $size: Int!){
        # 方法名
        findPosByPartnerId
        # 参数
        (
          partnerId: $partnerId, # 商家编号 (必填)
          page: $page, # (选填)
          size: $size,  # (选填)
        )
        # 返回字段
        {
          id
          posId     # 网点编号
          partnerId # 商户编号
          name      # 名称
          picture   # 图片
          contact   # 联系人姓名
          phone     # 电话
          accessType# 接入方式 (int) (0.未标记接入类型，需要人工核对; 1.边缘接入; 2.云端集成; 3.入链导流; 4.众敏核验; 5.用户核验; 6.自助录入)
          workState # 网点工作状态 (int) (0/2.离线; 100.空闲; 150.准备中; 200.工作中; 300.完成; 400.故障)
          openHours # 营业时间 (格式: 0024)
          address   # 地址
          province  # 省
          city      # 市
          district  # 区、县
          longitude # 经度 (double)
          latitude  # 纬度 (double)
          ywbTag    # 是否在运维宝中展示 (int)  (0.不展示; 1.展示)
          washerType# 洗车类型 (int)  (0.智能; 1.自助; 2.人工)
#          starLevel # 星级 (double) (范围: 0-5)
#          minPrice  # 最低价格 (int)
#          minPrice  # 最高价格 (int)
#          fromnode  # 数据来源
          createTime
          modifyTime
          state     # (int)
      }
    }`,
    variables: params
  })
}

// 查询所有商户用于select标签选择
function getPartnerList(){
  return apolloClient.query({
    fetchPolicy: 'no-cache',
    query: gql`query getPartnerList
    {
      # 方法名
      queryPartner
      # 参数 (必填)
      (
        partnerDTO: {
          page: 1,
          size: 1000,
          sort: ["createTime", "desc"],
          stateList: [1]
        }
      )
      # 返回字段
      {
        id
        partnerId # 商户编号
        name      # 公司名称
      }
    }`,
  })
}

// 查询所有商户（详细信息）
function getPartnerDetailList(params){
  return apolloClient.query({
    fetchPolicy: 'no-cache',
    query: gql`query getPartnerList(
      $partnerName: String,
      $province: String,
      $city: String,
      $district: String,
      $contactName: String,
      $stateList: [Int!],
    ){
      queryPartner
      # 参数 (必填)
      (
        partnerDTO: {
          #partnerId: null,   # 商户编号 (可选) (不填则需要有众敏权限, 填写则需要有商户权限)
          partnerName: $partnerName, # 商户名称 (可选) (模糊查询)
          province: $province,    # 省 (可选) (右匹配)
          city: $city,        # 市 (可选) (右匹配)
          district: $district,    # 区 (可选) (右匹配)
          contactName: $contactName, # 联系人姓名 (可选) (模糊查询)
          stateList: $stateList,  # 状态 (可选) (1.正在合作; 2.暂未合作)
          page: 1,
          size: 1000,
          sort: ["createTime", "desc"]
        }
      )
      # 返回字段
      {
        id
        partnerId # 商户编号
        name      # 公司名称
        phone     # 公司电话
        address   # 公司地址
        province  # 省
        city      # 市
        district  # 区
        description # 公司简介
        legalRepresentative # 法人姓名
        contact     # 联系人姓名
        contactPhone# 联系电话
        email       # 邮箱
        taxpayerNumber # 纳税人识别号
        bankName    # 开户行名称
        bankAccount # 银行账号
        wepayMerchantId # 收款用商户号
        supportCharge # (int) (0位.是否支持充值; 1位.单次是否支持链点)
        pubKey      # 公钥
        notifyURL   # 通知url
        startTime   # 合同开始日期
        endTime     # 合同终止日期
        balanceFlag # 余额标签
        createTime
        modifyTime
        state       # (int) 合作状态 (1.正在合作; 2.暂未合作)
      }
    }`,
    variables: params
  })
}

// 查询商户收费策略
function getPartnerFee(params){
  return apolloClient.query({
    fetchPolicy: "no-cache",
    query: gql`query findFeePolicyByPartnerId($partnerId: String!){
      # 方法名
      findFeePolicyByPartnerId
      # 参数
      (partnerId: $partnerId) # 商户编号 (必填)

      # 返回字段
      {
        id
        partnerId # 商户编号
        feeType   # 分润类型 (int) (1.按比例; 2.按绝对值)
        amount    # 具体分润参数 (int) (具体分润参数: 当type为1 时为百分比; 当type为2 是为分; 当type为1,且amount为100时,直接解冻)
        recipient # 接收方, 可以是商户,也可以是个人
        lastOrderPkID # 最后处理的订单主键ID (int)
        recipientType # 接收方类型 (int) (1.商户; 2.个人)
        flag      # 是否可以继续分润
        notifiers # 通知接收者 (多个则按逗号分隔)
        desc      # 备注信息
        createTime
        modifyTime
        state
        url      # 消息可引导的页面
      }
    }`,
    variables: params
  })
}

// 查询所有商户雇员
function getEmployeeList(params){
    return apolloClient.query({
      fetchPolicy: "no-cache",
      query: gql`query queryEmployee(
        $name: String,
        $stateList: [Int!],
        $partnerId: String,
        $userAccount: String,
        $page: Int!
      ){
        # 方法名
        queryEmployee
        # 参数 (必填)
        (
          employeeDTO: {
            name: $name,        # 雇员姓名 (可选) (模糊查询)
            stateList: $stateList,  # 状态 (可选) (-1.申请中; 1.有效; 2.无效)
            partnerId: $partnerId,   # 商户编号 (可选) (不填则需要有众敏权限, 填写则需要有商户权限)
            userAccount: $userAccount, # 用户账号 (可选)
            page: $page,
            size: 20,
            sort: ["createTime", "desc"]
            #popedom: null,     # 权限类型 (可选) (ALL, OMC, YWB)
          }
        )

        # 返回字段
        {
          id
          partnerId   # 商户编号
          userAccount # 用户账号
          name        # 雇员姓名
          popedom     # 权限 (ALL为全部; OMC|YWB等,用逗号隔开)
          desc        # 描述
          createTime
          modifyTime
          state       # 状态 (int) (-1.申请中; 1.有效; 2.无效)
        }
      }`,
      variables: params
    })
}

// 查询所有产品
function queryAllProduct(params){
  return apolloClient.query({
    fetchPolicy: 'no-cache',
    query: gql` query queryProduct(
      $partnerId: String!,
      $page: Int!,
    ){
      # 方法名
      queryProduct
      # 参数 (必填)
      (
        productDTO: {
          partnerId: $partnerId,     # 商户编号 (可选) (不填则需要有众敏权限, 填写则需要有商户权限)
          productName: null,   # 产品名称 (可选) (模糊查询)
          classifyList: [1,2], # 产品分类 (可选) (0.其他; 1.洗车服务类; 2.洗车券类; 3.代金券类; 4.众敏链点类; 5.有车邦充值类; 6.商家自定义产品; 10.余额充值保留类)
          stateList: [1],    # 状态 (可选) (1.在售; 2.下架)
          page: $page,
          size: 100,
          sort: ["state", "asc", "partnerId", "asc", "id", "asc"] # 排序方式 (可选)
        }
      )

      # 返回字段
      {
        id
        productType # 产品类型 (int)
        name        # 产品名称
        classify    # 产品分类 (int) (0.其他; 1.洗车服务类; 2.洗车券类; 3.代金券类; 4.众敏链点类; 5.有车邦充值类; 6.商家自定义产品; 10.余额充值保留类)
        partnerId   # 商户编号
        timeConsuming # 耗时 (int)
        price       # 价格 (int) (默认单位:分)
        priceUnit   # 价格单位
        description # 产品描述
        minNum      # 最小购买数量 (int)
        maxNum      # 最大购买数量 (int)
        createTime
        modifyTime
        state       # 状态 (int) (1.在售; 2.下架)
      }
    }`,
    variables: params
  })
}

// 根据网点编号，查询网点详细信息
function queryPosDetailByPosId(params){
  return apolloClient.query({
    fetchPolicy: 'no-cache',
    query: gql` query queryPosDetail($posId: String!){
      findPosInfoByPosId(posId: $posId) # 网点编号 (必填)
      # 返回字段
      {
        # 网点信息
        pos {
          id
          posId     # 网点编号
          partnerId # 商户编号
          fromnode  # 来源
          name      # 网点名称
          picture   # 图片
          contact   # 联系人
          phone     # 电话
          accessType# 接入方式 (int)  (0.未标记接入类型，需要人工核对; 1.边缘接入; 2.云端集成; 3.入链导流; 4.众敏核验; 5.用户核验; 6.自助录入)
          workState # 网点工作状态 (int)
          openHours # 营业时间 （格式 0024）
          openHoursV2 # 营业时间 (格式：00:00-24:00)
          address   # 地址
          province  # 省
          city      # 市
          district  # 区、县
          longitude # 经度 (double)
          latitude  # 纬度 (double)
          washerType# 洗车类型 (int) (0.智能; 1.自助; 2.人工)
          createTime
          modifyTime
          state # int
        }

        # 产品列表
        lstProduct {
          # 通用产品信息
          product {
            id
            productType # 产品类型 (int)
            name      # 名称
            classify  # 产品分类 (int) (0.其他/未分类; 1.洗车服务类; 2.洗车券类; 3.代金券类; 4.众敏链点类; 5.ycb余额充值类)
            partnerId # 商户编号
            posId     # 网点编号
            timeConsuming # 服务耗时 (int)
            price     # 价格 (int)
            priceUnit # 价格单位
            minNum    # 最小购买数量 (int)
            maxNum    # 最大购买数量 (int)
            createTime
            modifyTime
            state # int
          }
          # 实际启动的类型
          realType # (int)
          # 实际价格
          realPrice # (int)
        }

        # 设备信息
        device {
          deviceName # 设备名称 (IMEI号)
          token  # 会话token
          pubKey # 公钥
          snOfPartnerId # 归属商户的设备序号
        }

        # 网点附加信息
        posAdditionInfo {
          picUrl
          deliveryUrl # 现场启动服务的url, 如易捷现场二维码
          callMethod  # 调用方式 (0.众敏边缘接入；1.五分钟云云对接；2.有车邦云云对接；3.人工处理)
        }
      }
    }`,
    variables: params
  })
}

//查询所有满足条件的商家合作申请
function getPartnerApplyList(params){
  return apolloClient.query({
    fetchPolicy: "no-cache",
    query: gql`query getPartnerApplyList(
      $userAccount: String,
      $province: String,
      $city: String,
      $district: String,
      $washerTypeList: [Int!],
      $applyStateList: [Int!],
      $page: Int!,
      $size: Int!
    ){
      queryJoinApplyPos
      # 参数 (必填)
      (
        joinApplyPosDTO: {
          userAccount: $userAccount, # (可选) 申请人账号 (允许用户自查或众敏雇员查询)
          province: $province,    # (可选) 省 (右匹配)
          city: $city,        # (可选) 市 (右匹配)
          district: $district,    # (可选) 区 (右匹配)
          washerTypeList: $washerTypeList, # (可选) 洗车类型 (0.智能; 1.自助; 2.人工)
          applyStateList: $applyStateList, # (可选) 申请状态 (-1.驳回; 1.申请中; 2.成功)
          approver: null,        # (可选) 审批人账号
          beginCreateTime: null, # (可选) 创建时间_起始
          endCreateTime: null,   # (可选) 创建时间_截止
          page: $page,
          size: $size,
          sort: null
        }
      )

      # 返回字段
      {
        id
        userAccount # 申请人账号
        province    # 省
        city        # 市
        district    # 区
        address     # 地址
        washerType  # 洗车类型 (0.智能; 1.自助; 2.人工)
        deviceInfo  # 服务设备型号
        expectService # 期望服务
        contact     # 联系人
        phone       # 联系电话
        applyState  # 申请状态 (-1.驳回; 1.申请中; 2.成功)
        applyRemarks# 处理结果描述
        approver    # 审批人账号
        createTime
        modifyTime
      }
    }`,
    variables: params
  })
}

//查询所有满足条件的雇员申请
function getEmployeeApplyList(params){
  return apolloClient.query({
    fetchPolicy: "no-cache",
    query: gql`query getEmployeeApplyList(
      $userAccount: String,
      $partnerId: String!,
      $name: String,
      $applyStateList: [Int!],
      $page: Int!
    ){
      queryJoinApplyStaff
      # 参数 (必填)
      (
        joinApplyStaffDTO: {
          userAccount: $userAccount, # (可选) 申请人账号 (允许用户自查)
          partnerId: $partnerId,   # (可选) 商户编号 (填写需要则商户雇员权限, 不填则需要众敏雇员权限)
          name: $name,        # (可选) 雇员姓名
          applyStateList: $applyStateList, # (可选) 申请状态 (-1.驳回; 1.申请中; 2.成功)
          approver: null,        # (可选) 审批人账号
          beginCreateTime: null, # (可选) 创建时间_起始
          endCreateTime: null,   # (可选) 创建时间_截止
          page: $page,
          size: 20,
          sort: null
        }
      )

      # 返回字段
      {
        id
        userAccount # 申请人账号
        partnerId   # 商户编号
        name        # 雇员姓名
        phone       # 联系电话
        applyState  # 申请状态 (-1.驳回; 1.申请中; 2.成功)
        applyRemarks# 处理结果描述
        approver    # 审批人账号
        createTime
        modifyTime
      }
    }`,
    variables: params
  })
}

// 查询所有网点产品(众敏产品)
function queryGlobalProduct(params){
  return apolloClient.query({
    fetchPolicy: "no-cache",
    query: gql`query findGlobalProduct(
        $page: Int!
    ){
      findGlobalProduct
      # 参数
      (
        state: 1, # 状态 (必填) (1.在售; 2.下架)
        page: $page, # (可选)
        size: 100000 # (可选)
      )

      # 返回字段
      {
        id
        productType # 产品类型 (int)
        name        # 产品名称
        classify    # 产品分类 (int) (0.其他; 1.洗车服务类; 2.洗车券类; 3.代金券类; 4.众敏链点类; 5.有车邦充值类; 6.商家自定义产品; 10.余额充值保留类)
        partnerId   # 商户编号
        timeConsuming # 耗时 (int)
        price       # 价格 (int) (默认单位:分)
        priceUnit   # 价格单位
        description # 产品描述
        minNum      # 最小购买数量 (int)
        maxNum      # 最大购买数量 (int)
        createTime
        modifyTime
        state       # 状态 (int) (1.在售; 2.下架)
      }
    }`,
    variables: params
  })
}

// 查询所有可添加产品的网点
function getAllowAddProductPos(params){
  return apolloClient.query({
    fetchPolicy: 'no-cache',
    query: gql`query queryPos(
      $partnerId: String!,
      $accessTypeList: [Int!],
    ){
      queryPos
      # 参数 (全部可选)
      (
        posDTO: {
          partnerId: $partnerId, # 商户编号
#          province: "广东省", # 省
#          city: "深圳市",     # 市
#          district: "南山区", # 区
          accessTypeList: $accessTypeList, # 接入方式 (int)  (0.未标记接入类型，需要人工核对; 1.边缘接入; 2.云端集成; 3.入链导流; 4.众敏核验; 5.用户核验; 6.自助录入)
#          washerTypeList: [0, 1, 2], # 洗车类型 (int) (0.智能; 1.自助; 2.人工)
#          workStateList: [0,1,2,3,4,5], # 网点工作状态 (int) (0.空闲; 1. 工作中; 2.维修; 3.歇业; 4.离线; 5.故障)
#          minStarLevel: 0, # 最低星级 (double)
#          maxStarLevel: 5, # 最高星级 (double)
#          minPrice: null,  # 最低价格 (int)
#          maxPrice: null,  # 最高价格 (int)
          page: 1,
          size: 10000
        }
      )

      # 返回字段
      {
        id
        posId     # 网点编号
        partnerId # 商户编号
        name      # 名称
        picture   # 图片
        contact   # 联系人姓名
        phone     # 电话
        accessType# 接入方式 (int) (0.未标记接入类型，需要人工核对; 1.边缘接入; 2.云端集成; 3.入链导流; 4.众敏核验; 5.用户核验; 6.自助录入)
        workState # 网点工作状态 (int) (0/2.离线; 100.空闲; 150.准备中; 200.工作中; 300.完成; 400.故障)
        openHours # 营业时间 (格式: 0024)
        openHoursV2 # 营业时间 (格式：00:00-24:00)
        address   # 地址
        province  # 省
        city      # 市
        district  # 区、县
        longitude # 经度 (double)
        latitude  # 纬度 (double)
        ywbTag    # 是否在运维宝中展示 (int)  (0.不展示; 1.展示)
        washerType# 洗车类型 (int)  (0.智能; 1.自助; 2.人工)
        starLevel # 星级 (double) (范围: 0-5)
        minPrice  # 最低价格 (int)
        minPrice  # 最高价格 (int)
        fromnode  # 数据来源
        createTime
        modifyTime
        state     # (int)
      }
    }`,
    variables: params
  })
}

// 根据posId产品
function queryProductByPosId(params){
  return apolloClient.query({
    fetchPolicy: 'no-cache',
    query: gql`query findProduct(
        $posId: String!,
        $page: Int!,
    ){
      findP2PInfoByPosId
      # 参数
      (
        posId: $posId, # 网点编号 (必填)
        page: $page,
        size: 20
      )

      # 返回字段
      {
        p2p {
          id
          posId       # 网点编号
          partnerId   # 商户编号
          productType # 产品类型
          productName # 产品名称
          supported   # 是否支持产品 (1.支持/上架； 2.不支持/下架)
          realType    # 真实产品类型
          realPrice   # 真实加个
          createTime
          modifyTime
          state
        }

        product {
          id
          productType # 产品类型 (int)
          name        # 产品名称
          classify    # 产品分类 (int) (0.其他; 1.洗车服务类; 2.洗车券类; 3.代金券类; 4.众敏链点类; 5.有车邦充值类; 6.商家自定义产品; 10.余额充值保留类)
          partnerId   # 商户编号
          timeConsuming # 耗时 (int)
          price       # 价格 (int) (默认单位:分)
          priceUnit   # 价格单位
          description # 产品描述
          minNum      # 最小购买数量 (int)
          maxNum      # 最大购买数量 (int)
          createTime
          modifyTime
          state       # 状态 (int) (1.在售; 2.下架)
        }
      }
    }`,
    variables: params
  })
}

//判断当前用户是否是众敏雇员
function queryzmEmployeeIndentity(){
  return apolloClient.query({
    query: gql`query zhmEmployeeAuth{
      zhmEmployeeAuth
    }`
  })
}

// 查询收银方式调整日志
function queryChangeCashierLogs(params){
  return apolloClient.query({
    query: gql`query queryChangeCashierLogs(
      $userAccount: String,
      $partnerId: String,
      $page: Int!,
    ){
        queryOperationFlow
        # 参数 (必填)
        (
            operationFlowDTO: {
                userAccount: $userAccount,     # 操作者账号 (可选)
                partnerId: $partnerId,       # 操作所属商户 (可选)
                operationType: null,   # 操作类型 (可选)
                beginCreateTime: null, # 起始时间 (可选)
                endCreateTime: null,   # 截止时间 (可选)
                page: $page,
                size: 20
                sort: ["createTime", "desc", "id", "desc"] # 排序方式 (可选)
            }
        )
        # 返回字段
        {
            id
            userAccount   # 操作者账号
            partnerId     # 操作所属商户
            operationType # 操作类型
            operationDesc # 操作描述
            createTime
        }
    }`,
    variables: params
  })
}

// 根据订单号查询订单
function getOrderInfoList(params){
  return apolloClient.query({
    fetchPolicy: 'no-cache',
    query: gql`query queryOrderInfo(
      $orderId: String,
      $openId: String,
      $posId: String,
      $beginOrderTime: String,
      $endOrderTime: String,
      $beginModifyTime: String,
      $endModifyTime: String,
      $page: Int!
    ){
      queryOrderInfo
      # 参数
      (
        orderDTO: {
          orderId: $orderId,   #(可选) 订单编号
          userAccount: $openId, #(可选) 用户账号 (用户可自查)
          partnerId: null, #(可选) 商户编号 (填写则需要商户权限，不填则需要众敏权限)
          posId: $posId,     #(可选) 网点编号
          plate: null,     #(可选) 车牌号
          balancePartnerId: null, #(可选) 余额所属商户
          invoiceFlag: null,      #(可选) 发票标识(int) (0.未开发票; 1.已申请开发票; 2.已开票)
          payMethodList: [1, 2],  #(可选) 现金支付方式 (List<Int>) (1.微信；2.支付宝)
          completeStateList: [1,2,3,4], #(可选) 订单完成状态 (List<Int>) (1.未支付; 2.已支付,待发货; 3.已发货,完成; 4.超时未发货,已经退款;)
          beginOrderTime: $beginOrderTime,    #(可选) 起始_下单时间
          endOrderTime: $endOrderTime,      #(可选) 截止_下单时间
          beginModifyTime: $beginModifyTime,   #(可选) 起始_变更时间
          endModifyTime: $endModifyTime,     #(可选) 截止_变更时间
          beginCompleteTime: null, #(可选) 起始_订单完成时间
          endCompleteTime: null,   #(可选) 截止_订单完成时间
          page: $page,
          size: 200
        }
      )

      # 返回字段
      {
        order {
          id
          orderId      # 订单编号
          partnerId    # 合作商户编号
          posId        # 下单网点编号
          orderPosName # 下单网点名称
          userAccount  # 用户账号
          plateNum     # 车牌号
          balancePay   # 余额支付金额 (int)
          pointsPay    # 链点支付金额 (int)
          couponId     # 洗车券编号
          couponPay    # 洗车券支付金额 (int)
          cashCouponId # 代金券编号
          cashCouponPay# 代金券支付金额 (int)
          amount       # 现金支付金额 (int)
          payMethod    # 现金支付方式 (int) (1.微信；2.支付宝)
          completeState# 订单完成状态 (int) (1.未支付; 2.已支付,待发货; 3.已发货,完成; 4.超时未发货,已经退款;)
          orderTime    # 下单时间
          servicePosName # 实际服务网点名称
          completeTime # 服务受理时间
          agentRewardState # 推广奖励发放状态 (int) (0.未发放; 1.已发放)
          agentId # 代理人编号
          sign    # 签名
          refundAmount # 退款金额 (int)
          refundTimes  # 退款次数 (int)
          balancePartnerId # 余额所属商户编号
          invoiceFlag  # 是否开发票 (int) (0.未开发票; 1.申请中; 2.已开票)
          orderIdOfWepay # 微信支付交易单号
          freezeFlag #int 0：取消冻结；1：冻结
          remark
          createTime
          modifyTime
          state #int
        }

        o2pList {
          id
          orderId      # 订单编号
          userAccount  # 用户账号
          posId        # 网点编号
          productType  # 产品类型
          productName  # 产品名称
          productPrice # 产品价格
          num          # 购买数量
          productExtra # 产品附加信息，购买链点时，可以指定为哪个partner购买
          createTime
          modifyTime
          state
        }
      }
    }`,
    variables: params
  })
}

// 查询商户微信收款账户
function queryWxPayAccountByPartnerId(){
  return apolloClient.query({
    fetchPolicy: "no-cache",
    query: gql`query findMerchantWePayByPartnerIdAndState{
      findMerchantWePayByPartnerIdAndState
      # 参数
      (
        partnerId: null, # 商户编号 (可选) (填写则要有商户权限, 不填则要有众敏权限)
        state: null, # 状态 (可选) (-1.申请中; 1.有效; 2.无效)
        page: 1,
        size: 20
      )

      # 返回字段
      {
        id
        name # 商户名称
        merchantId # 微信商户号
        partnerId  # 商户编号
        merchantSN # 微信商户号API证书编码
        merchantAPIV3Key # 微信商户号API3的token
        merchantPrivateKey # 微信商户号的证书私钥
        createTime
        modifyTime
        state      # (int) (-1.申请中; 1.有效; 2.无效)
      }
    }`
  })
}

// 根据partnerId查询商户详细信息
function findPartnerByPartnerId(partnerId){
  return apolloClient.query({
    fetchPolicy: "no-cache",
    query: gql`query findPatnerByPartnerId(
      $partnerId: String!
    ){
      findPartnerByPartnerId
      # 参数
      (
        partnerId: $partnerId, # 商户编号 (必填)
        state: 1 # 状态 (必填)
      )

      # 返回字段
      {
        id
        partnerId # 商户编号
        name      # 公司名称
        phone     # 公司电话
        address   # 公司地址
        province  # 省
        city      # 市
        district  # 区
        description # 公司简介
        legalRepresentative # 法人姓名
        contact     # 联系人姓名
        contactPhone# 联系电话
        email       # 邮箱
        taxpayerNumber # 纳税人识别号
        bankName    # 开户行名称
        bankAccount # 银行账号
        wepayMerchantId # 收款用商户号
        supportCharge # (int) (0位.是否支持充值; 1位.单次是否支持链点)
        pubKey      # 公钥
        notifyURL   # 通知url
        startTime   # 合同开始日期
        endTime     # 合同终止日期
        balanceFlag # 余额标签
        createTime
        modifyTime
        state       # (int) 合作状态 (1.正在合作; 2.暂未合作)
      }
    }`,
    variables: {
      partnerId
    }
  })
}

// 根据传递的条件查询对应的网点
function queryPosInfoList(params){
  return apolloClient.query({
    fetchPolicy: 'no-cache',
    query: gql`query queryPosInfo(
      $partnerId: String,
      $fromnode: String,
      $keyword: String,
      $province: String,
      $city: String,
      $district: String,
      $accessTypeList: [Int],
      $washerTypeList: [Int],
      $workStateList: [Int],
      $minStarLevel: Float,
      $maxStarLevel: Float,
      $minPrice: Int,
      $maxPrice: Int,
      $page: Int,
      $size: Int
    ){
      # 方法名
      queryPosInfo
      # 参数 (全部可选)
      (
        posDTO: {
          partnerId: $partnerId, # 商户编号
          fromnode: $fromnode, # 商户来源
          keyword: $keyword, # 关键字 (根据名称和地址模糊查询)
          province: $province, # 省
          city: $city,     # 市
          district: $district, # 区
          accessTypeList: $accessTypeList, # 接入方式 (int)  (0.未标记接入类型，需要人工核对; 1.边缘接入; 2.云端集成; 3.入链导流; 4.众敏核验; 5.用户核验; 6.自助录入)
          washerTypeList: $washerTypeList, # 洗车类型 (int) (0.智能; 1.自助; 2.人工)
          workStateList: $workStateList, # 网点工作状态 (int) (0.空闲; 1. 工作中; 2.维修; 3.歇业; 4.离线; 5.故障)
          minStarLevel: $minStarLevel, # 最低星级 (double)
          maxStarLevel: $maxStarLevel, # 最高星级 (double)
          minPrice: $minPrice,  # 最低价格 (int)
          maxPrice: $maxPrice,  # 最高价格 (int)
          page: $page,
          size: $size
        }
      )

      # 返回字段
      {
        # 网点信息
        pos {
          id
          posId     # 网点编号
          partnerId # 商户编号
          name      # 网点名称
          picture   # 图片
          contact   # 联系人
          phone     # 电话
          accessType# 接入方式 (int)  (0.未标记接入类型，需要人工核对; 1.边缘接入; 2.云端集成; 3.入链导流; 4.众敏核验; 5.用户核验; 6.自助录入)
          workState # 网点工作状态 (int)
          openHours # 营业时间 （格式 0024）
          openHoursV2 # 营业时间 (格式：00:00-24:00)
          address   # 地址
          province  # 省
          city      # 市
          district  # 区、县
          longitude # 经度 (double)
          latitude  # 纬度 (double)
          ywbTag    # 运维宝标识 (int) (0.不展示; 1.展示)
          washerType# 洗车类型 (int) (0.智能; 1.自助; 2.人工)
          starLevel # 星级 (double) (0-5)
          minPrice  # 最低价格 (int)
          minPrice  # 最高价格 (int)
          fromnode  # 数据来源
          createTime
          modifyTime
          state # int
        }

        # 设备信息
        device {
          id
          deviceName # 设备名称 (IMEI号)
          partnerId  # 商户编号
          posName    # 网点名称
          posId      # 网点编号
          snOfPartnerId # 归属商户的设备序号
          pubKey # 公钥
          token  # 会话token
          workState # 设备工作状态 (int)(2.离线; 100.洗车机空闲; 150.洗车机工作准备中; 200.洗车机正在工作; 300.洗车机完成工作; 400.洗车机故障)
          createTime
          modifyTime
          state # int
        }
      }

    }`,
    variables: params
  })
}

// 查询用户详细信息
function queryUserInfo(userAccount){
  return apolloClient.query({
    fetchPolicy: 'no-cache',
    query: gql`query queryUserInfo($userAccount: String!){
      # 方法名
      findUserByUserAccount
      # 参数
      (userAccount: $userAccount) #(必填) 用户账号

      # 返回字段
      {
        id
        userAccount   # 用户账号 (即openId)
        password      # 密码
        nickname      # 昵称
        headImage     # 头像
        phone         # 联系电话
        plateNum      # 车牌号
        source        # 用户来源 (int)  (1.微信; 2.众敏账号注册)
        carWashMethod # 常用洗车方式 (int)  (0.未设置；1.超洗；2.精洗；4.快洗)
        payMethod     # 常用支付方式 (int)  (0.未设置；1.微信；2.支付宝)
        userType      # 用户类型 (int)  (1.普通；2.vip)
        regTime       # 注册时间
        lastLoginTime # 最后一次登录时间
        vipLevel      # vip等级 (int)  (1.微信关注公众号；400.取消关注公众号)
        vipStartTime  # vip开始时间
        vipEndTime    # vip结束时间
        authMode      # 验证方式 (int)  (0.未设置；1.车牌；4.密码)
        agentId       # 推广员账号
        agentRewardState # 推广奖励发放状态 (按位运算: 0.未发放;  1.已发放;  2.填写车牌已奖励;  4.填写手机已奖励)
        unionId       # 微信开放平台id，用于实现多个公众号之间的连通
        subscribe     # 是否关注公众号 (int)  (0.没有关注; 1.已关注)
        sourcePos     # 注册来源站点
        createTime
        modifyTime
        state
      }
    }`,
    variables: {
      userAccount
    }
  })
}

// 查询用户链点数额
function queryUserPoints(userId){
  return apolloClient.query({
    fetchPolicy: "no-cache",
    query: gql`query queryUserPoints($userId: String!){
      # 方法名
      findOnePoints
      # 参数
      (userId: $userId) #(必填) 用户账号

      # 返回值
      {
        id
        userAccount # 用户账号(openId)
        type        # 账号类型 (int) (0.借记; 1.贷记)
        points      # 链点余额 (long)
        remark      # 备注
        version     # 版本号 (int)
        sign        # 签名
        createTime
        modifyTime
      }
    }`,
    variables: {
      userId
    }
  })
}

// 查询门店信息
function getPosInfo(posId){
  return apolloClient.query({
    fetchPolicy: "no-cache",
    query: gql`query getPosInfo(
      $posId: String!
    ){
      findPosAdditionInfoByPosId
      (
        posId: $posId, #(必填) 网点编号
      )
      # 返回值字段
      {
        id
        posId,       # 网点编号
        picUrl,      # 图片url
        deliveryUrl, # 现场启动服务的url, 如易捷现场二维码
        callMethod,  # 调用方式 (0.众敏边缘接入；1.五分钟云云对接；2.有车邦云云对接；3.人工处理)
        createTime,
        modifyTime
      }
    }`,
    variables: {
      posId
    }
  })
}

// 查询用户订单
function getOrderInfo(params){
  return apolloClient.query({
    fetchPolicy: 'no-cache',
    query: gql`query getOrderInfo(
      $orderId: String
    ){
      queryOrderInfo
      # 参数
      (
        orderDTO: {
          orderId: $orderId,   #(可选) 订单编号
          userAccount: null, #(可选) 用户账号 (用户可自查)
          partnerId: null, #(可选) 商户编号 (填写则需要商户权限，不填则需要众敏权限)
          posId: null,     #(可选) 网点编号
          plate: null,     #(可选) 车牌号
          balancePartnerId: null, #(可选) 余额所属商户
          invoiceFlag: null,      #(可选) 发票标识(int) (0.未开发票; 1.已申请开发票; 2.已开票)
          payMethodList: null,  #(可选) 现金支付方式 (List<Int>) (1.微信；2.支付宝)
          completeStateList: null, #(可选) 订单完成状态 (List<Int>) (1.未支付; 2.已支付,待发货; 3.已发货,完成; 4.超时未发货,已经退款;)
          beginOrderTime: null,    #(可选) 起始_下单时间
          endOrderTime: null,      #(可选) 截止_下单时间
          beginModifyTime: null,   #(可选) 起始_变更时间
          endModifyTime: null,     #(可选) 截止_变更时间
          beginCompleteTime: null, #(可选) 起始_订单完成时间
          endCompleteTime: null,   #(可选) 截止_订单完成时间
          page: 1,
          size: 200
        }
      )

      # 返回字段
      {
        order {
          id
          orderId      # 订单编号
          partnerId    # 合作商户编号
          posId        # 下单网点编号
          orderPosName # 下单网点名称
          userAccount  # 用户账号
          plateNum     # 车牌号
          balancePay   # 余额支付金额 (int)
          pointsPay    # 链点支付金额 (int)
          couponId     # 洗车券编号
          couponPay    # 洗车券支付金额 (int)
          cashCouponId # 代金券编号
          cashCouponPay# 代金券支付金额 (int)
          amount       # 现金支付金额 (int)
          payMethod    # 现金支付方式 (int) (1.微信；2.支付宝)
          completeState# 订单完成状态 (int) (1.未支付; 2.已支付,待发货; 3.已发货,完成; 4.超时未发货,已经退款;)
          orderTime    # 下单时间
          servicePosName # 实际服务网点名称
          completeTime # 服务受理时间
          agentRewardState # 推广奖励发放状态 (int) (0.未发放; 1.已发放)
          agentId # 代理人编号
          sign    # 签名
          refundAmount # 退款金额 (int)
          refundTimes  # 退款次数 (int)
          balancePartnerId # 余额所属商户编号
          invoiceFlag  # 是否开发票 (int) (0.未开发票; 1.申请中; 2.已开票)
          orderIdOfWepay # 微信支付交易单号
          freezeFlag #int 0：取消冻结；1：冻结
          remark
          createTime
          modifyTime
          state #int
        }

        o2pList {
          id
          orderId      # 订单编号
          userAccount  # 用户账号
          posId        # 网点编号
          productType  # 产品类型
          productName  # 产品名称
          productPrice # 产品价格
          num          # 购买数量
          productExtra # 产品附加信息，购买链点时，可以指定为哪个partner购买
          createTime
          modifyTime
          state
        }
      }
    }`,
    variables: params
  })
}

// 根据posId查询网点订单
function queryOrderByPosId(params){
  return apolloClient.query({
    fetchPolicy: "no-cache",
    query: gql`query queryOrderByPosId(
      $posId: String!,
      $page: Int!,
      $size: Int!
    ){
      findOrderByPosId
      # 参数
      (
        posId: $posId, # 网点编号 (必填)
        page: $page,
        size: $size
      )

      # 返回字段
      {
        order {
          id
          orderId      # 订单编号
          partnerId    # 合作商户编号
          posId        # 下单网点编号
          orderPosName # 下单网点名称
          userAccount  # 用户账号
          plateNum     # 车牌号
          balancePay   # 余额支付金额 (int)
          pointsPay    # 链点支付金额 (int)
          couponId     # 洗车券编号
          couponPay    # 洗车券支付金额 (int)
          cashCouponId # 代金券编号
          cashCouponPay# 代金券支付金额 (int)
          amount       # 现金支付金额 (int)
          payMethod    # 现金支付方式 (int) (1.微信；2.支付宝)
          completeState# 订单完成状态 (int) (1.未支付; 2.已支付,待发货; 3.已发货,完成; 4.超时未发货,已经退款;)
          orderTime    # 下单时间
          servicePosName # 实际服务网点名称
          completeTime # 服务受理时间
          agentRewardState # 推广奖励发放状态 (int) (0.未发放; 1.已发放)
          agentId # 代理人编号
          sign    # 签名
          refundAmount # 退款金额 (int)
          refundTimes  # 退款次数 (int)
          balancePartnerId # 余额所属商户编号
          invoiceFlag  # 是否开发票 (int) (0.未开发票; 1.申请中; 2.已开票)
          orderIdOfWepay # 微信支付交易单号
          freezeFlag #int 0：取消冻结；1：冻结
          remark
          createTime
          modifyTime
          state #int
        }

        # 该订单对应的产品列表
        lstProduct {
          id
          productType # 产品类型 (int)
          name      # 名称
          classify  # 产品分类 (int) (0.其他/未分类; 1.洗车服务类; 2.洗车券类; 3.代金券类; 4.众敏链点类; 5.ycb余额充值类)
          partnerId # 商户级别
          posId     # 网点级别
          timeConsuming # 服务耗时 (int)
          price     # 价格 (int)
          priceUnit # 价格单位
          minNum    # 最小购买数量 (int)
          maxNum    # 最大购买数量 (int)
          createTime
          modifyTime
          state # int
        }
      }
    }`,
    variables: params
  })
}

// 查询小猫网点的管理员启动洗车账户
function findAllAutomanAccount(params){
  return apolloClient.query({
    fetchPolicy: "no-cache",
    query: gql`query findAllAutomanAccount(
      $page: Int,
      $size: Int,
    ){
      findAllAutomanAccount
      # 参数
      (
        page: $page,  #(可选)
        size: $size, #(可选)
        sort: ["id,desc"] #(可选)
      )

      # 返回字段
      {
        id
        userId      # 支付使用的user_id
        cardId      # 支付使用的card_id
        smallId     # 支付使用的small_id
        accountName # 账号名字
        openid      # 小猫侧open_id
        token       # token
        leftTimes   # 次卡剩余次数
        createTime
        modifyTime
        updateTime # 最近更新到Redis的时间
        state      # 仅当为1时，数据有效
      }
    }`,
    variables: params
  })
}

// 查询易捷网点的管理启动洗车账户
function findAllYijieAccount(params){
  return apolloClient.query({
    fetchPolicy: "no-cache",
    query: gql`query findAllYijieAccount(
      $page: Int,
      $size: Int
    ){
      findAllYijieAccount
      # 参数
      (
        page: $page,  #(可选)
        size: $size, #(可选)
        sort: ["id,desc"] #(可选)
      )

      # 返回字段
      {
        id
        cardId      # 支付使用的card_id
        token       # token
        leftTimes   # 次卡剩余次数
        createTime
        modifyTime
        state      # 仅当为1时，数据有效
      }
    }`,
    variables: params
  })
}

// 查询网点二维码
function queryQrInfo(params) {
  return apolloClient.query({
    fetchPolicy: "no-cache",
    query: gql`query queryQrInfo(
      $posId: String,
      $fromnode: String
    ){
        # 方法名
        findByPosIdAndFromNode
        # 参数
        (
          posId: $posId, #(可选) 网点编号
          fromnode: $fromnode     #(可选) 网点来源
        )

        # 返回字段
        {
          id
          qrUrl # 二维码Url
        }
    }`,
    variables: params
  })
}

// 查询在线用户列表
function queryOnlineUserList(params){
  return apolloClient.query({
    fetchPolicy:"no-cache",
    query:gql`query queryOnlineUserList(
      $page:Int,
      $size:Int
    ){
      # 方法名
        findAllOnlineUser
      # 参数
        (
          page: $page, #(可选)
          size: $size  #(可选)
        )

      # 返回字段
        {
          id
          userAccount
          onlineStatus
          lastSessionId
          modifyTime
          nickname
          headImage
          phone
          customerAccount
          posId
          orderId
        }
      }`,
    variables:params
  })
}

// 根据管理员对评论的处理状态查询评论
function queryCommentByAdminHandleState(params){
  return apolloClient.query({
    fetchPolicy: "no-cache",
    query: gql`query queryCommentByAdminHandleState(
        $processStatusList: [Int!],
        $partnerId: String,
        $posId: String,
        $page: Int,
        $size: Int
    ){
        # 方法名
        findCommentAndReplyByProcessStatus
        # 参数
        (
            processStatusList:  $processStatusList, #(可选) 管理员处理状态列表 (-1.无需处理; 0.未处理; 1.已处理; 2.已拒绝)
            partnerId: $partnerId,        #(可选) 商户编号
            posId: $posId,            #(可选) 网点编号
            page: $page,
            size: $size
        )

        # 返回字段
        {
          comment {
            id
            sessionId   # 会话编号
            commentType # 类型 (1.评价; 2.回复; 3.回复的回复)
            parentId    # 父级评价的ID
            userAccount # 评论者账号
            isAdmin     # 是否是管理员 (0.否; 1.是)
            comment     # 评价内容
            toUserAccount # 被回复的用户账号
            partnerId   # 商户编号
            posId       # 网点编号
            orderId     # 订单编号
            createTime  # 创建时间
            readStatus  # 已读状态 (-1.无需处理; 0.未读; 1.已读)
            adminProcessStatus # 管理员处理状态 (-1.无需处理; 0.未处理; 1.已处理; 2.已拒绝)
          }

          replyList {
            id
            sessionId   # 会话编号
            commentType # 类型 (1.评价; 2.回复; 3.回复的回复)
            parentId    # 父级评价的ID
            userAccount # 评论者账号
            isAdmin     # 是否是管理员 (0.否; 1.是)
            comment     # 评价内容
            toUserAccount # 被回复的用户账号
            partnerId   # 商户编号
            posId       # 网点编号
            orderId     # 订单编号
            createTime  # 创建时间
            readStatus  # 已读状态 (-1.无需处理; 0.未读; 1.已读)
            adminProcessStatus # 管理员处理状态 (-1.无需处理; 0.未处理; 1.已处理; 2.已拒绝)
          }
        }
    }`,
    variables: params
  })
}

// 查询评论的网点信息
function queryCommentPosInfo(posId){
  return apolloClient.query({
    fetchPolicy: "no-cache",
    query: gql`query queryCommentPosInfo(
      $posId: String!
    ){
      findPosInfoByPosId(posId: $posId) # 网点编号 (必填)
      # 返回字段
      {
          # 网点信息
          pos {
              id
              posId     # 网点编号
              name      # 网点名称
          }
      }
    }`,
    variables: {
      posId
    }
  })
}

// 根据orderId查询对应的订单
function queryOrderByOrderId(orderId) {
  return apolloClient.query({
    fetchPolicy: 'no-cache',
    query: gql`query findOrderByOrderId($orderId: String!){
      findOrderByOrderId(orderId: $orderId){
        order{
          modifyTime #修改时间
          userAccount #用户id
          posId #下单门店id
          orderPosName #下单门店名称
          orderId #订单号
          completeState #订单完成状态
          createTime #订单创建时间
          completeTime
          amount       # 现金支付金额 (int)
          balancePay   # 余额支付金额 (int)
          pointsPay    # 链点支付金额 (int)
          orderIdOfWepay   # 微信支付交易单号
        }
        # 该订单对应的产品列表
        lstProduct {
          id
          productType # 产品类型 (int)
          name      # 名称
          classify  # 产品分类 (int) (0.其他/未分类; 1.洗车服务类; 2.洗车券类; 3.代金券类; 4.众敏链点类; 5.ycb余额充值类)
          partnerId # 商户级别
          posId     # 门店级别
          timeConsuming # 服务耗时 (int)
          price     # 价格 (int)
          priceUnit # 价格单位
          minNum    # 最小购买数量 (int)
          maxNum    # 最大购买数量 (int)
          createTime
          modifyTime
          state # int
        }
      }
    }`,
    variables: {
      orderId
    }
  })
}

function queryPosListByCouponActivity(params) {
  return apolloClient.query({
    fetchPolicy: "no-cache",
    query: gql`query findPosInfo(
        $partnerId: String
    ){
        # 方法名
        queryPosInfo
        # 参数 (全部可选)
        (
            posDTO: {
                partnerId: $partnerId, # 商户编号
                page: 1,
                size: 10000
            }
        )

        # 返回字段
        {
            # 网点信息
            pos {
                id
                posId     # 网点编号
                partnerId # 商户编号
                name      # 网点名称
            }

            # 产品列表
            lstProduct {
                # 通用产品信息
                product {
                    id
                    productType # 产品类型 (int)
                    name      # 名称
                    classify  # 产品分类 (int) (0.其他/未分类; 1.洗车服务类; 2.洗车券类; 3.代金券类; 4.众敏链点类; 5.ycb余额充值类)
                    partnerId # 商户编号
                    posId     # 网点编号
                    price     # 价格 (int)
                }
                # 实际启动的类型
                realType # (int)
                # 实际价格
                realPrice # (int)
            }
        }
    }`,variables: params
  })
}

// 根据posId查询门店名称
function queryPosNameByPosId(params) {
  return apolloClient.query({
    fetchPolicy: "no-cache",
    query: gql`query findPosInfoByPosId(
      $posId: String!
    ) {
      findPosInfoByPosId
      (posId: $posId) # 网点编号 (必填)
      {
        pos {
          name
        }
      }
    }`,variables: params
  })
}

// 查询产品列表
function queryProductList(params) {
  return apolloClient.query({
    fetchPolicy: "no-cache",
    query: gql`query queryProductList(
        $partnerId: String!
    ) {
        findGlobalProduct
        # 参数
        (
            state: 1, # 状态 (必填) (1.在售; 2.下架)
            page: 1, # (可选)
            size: 10000 # (可选)
        )

        # 返回字段
        {
            id
            productType # 产品类型 (int)
            name        # 产品名称
            classify    # 产品分类 (int) (0.其他; 1.洗车服务类; 2.洗车券类; 3.代金券类; 4.众敏链点类; 5.有车邦充值类; 6.商家自定义产品; 10.余额充值保留类)
            partnerId   # 商户编号
            timeConsuming # 耗时 (int)
            price       # 价格 (int) (默认单位:分)
            priceUnit   # 价格单位
            description # 产品描述
            minNum      # 最小购买数量 (int)
            maxNum      # 最大购买数量 (int)
            createTime
            modifyTime
            state       # 状态 (int) (1.在售; 2.下架)
        }

        # 方法名
        queryProduct
        # 参数 (必填)
        (
            productDTO: {
                partnerId: $partnerId,     # 商户编号 (可选) (不填则需要有众敏权限, 填写则需要有商户权限)
                productName: null,   # 产品名称 (可选) (模糊查询)
                classifyList: [1,2], # 产品分类 (可选) (0.其他; 1.洗车服务类; 2.洗车券类; 3.代金券类; 4.众敏链点类; 5.有车邦充值类; 6.商家自定义产品; 10.余额充值保留类)
                stateList: [1],    # 状态 (可选) (1.在售; 2.下架)
                page: 1,
                size: 10000,
                sort: ["state", "asc", "partnerId", "asc", "id", "asc"] # 排序方式 (可选)
            }
        )

        # 返回字段
        {
            id
            productType # 产品类型 (int)
            name        # 产品名称
            classify    # 产品分类 (int) (0.其他; 1.洗车服务类; 2.洗车券类; 3.代金券类; 4.众敏链点类; 5.有车邦充值类; 6.商家自定义产品; 10.余额充值保留类)
            partnerId   # 商户编号
            timeConsuming # 耗时 (int)
            price       # 价格 (int) (默认单位:分)
            priceUnit   # 价格单位
            description # 产品描述
            minNum      # 最小购买数量 (int)
            maxNum      # 最大购买数量 (int)
            createTime
            modifyTime
            state       # 状态 (int) (1.在售; 2.下架)
        }
    }`,
    variables: params
  })
}

export {
  getAllFlowDailyReport,          // 查询所有每日报表日志
  addPos,                         // 添加一个网点
  getAssetBalance,                // 获取当前商户链点流水记录
  getPoints,                      // 获取当前商户链点流水记录，（为什么相同的接口写了两遍）
  getWithDrawRecords,             // 查询商家提现记录
  geRefundRecords,                // 查询退款记录
  getInvoiceRecords,              // 查询发票记录
  getInvoiceOfUser,               // 查询发票抬头信息
  getPosListByPartnerId,          // 根据服务商id查询所有网点
  getPartnerList,                 // 查询所有商户用于select标签选择
  getPartnerDetailList,           // 查询所有商户（详细信息）
  getPartnerFee,                  // 查询商户收费策略
  getEmployeeList,                // 查询所有商户雇员
  queryAllProduct,                // 查询所有产品
  queryPosDetailByPosId,          // 根据网点编号，查询网点详细信息
  getPartnerApplyList,            // 查询所有满足条件的商家合作申请
  getEmployeeApplyList,           // 查询所有满足条件的雇员申请
  queryGlobalProduct,             // 查询所有网点产品(众敏产品)
  getAllowAddProductPos,          // 查询所有可添加产品的网点
  queryProductByPosId,            // 根据posId产品
  queryzmEmployeeIndentity,       // 判断当前用户是否是众敏雇员
  queryChangeCashierLogs,         // 查询收银方式调整日志
  getOrderInfoList,               // 查询订单详细信息列表
  queryWxPayAccountByPartnerId,   // 查询商户微信收款账户
  findPartnerByPartnerId,         // 根据商户id查询商户信息
  queryPosInfoList,               // 根据名字查询对应网点
  queryUserInfo,                  // 查询用户详细信息
  queryUserPoints,                // 查询用户链点数额
  getPosInfo,                     // 查询门店信息
  getOrderInfo,                   // 查询订单信息
  queryOrderByPosId,              // 根据posId查询网点服务记录
  findAllAutomanAccount,          // 查询小猫网点的管理员启动洗车账户
  findAllYijieAccount,            // 查询易捷网点的管理启动洗车账户
  queryQrInfo,                    //  查询网点二维码
  queryOnlineUserList,            // 查询在线用户列表
  queryCommentByAdminHandleState, // 根据管理员对评论的处理状态查询评论
  queryCommentPosInfo,            // 查询评论所需的网点信息
  queryOrderByOrderId,            // 根据orderId查询对应的订单
  queryPosListByCouponActivity,   // 创建优惠券活动页面查询门店列表
  queryPosNameByPosId,            // 根据posId查询门店名称
  queryProductList,               // 查询产品列表
}



// WEBPACK FOOTER //
// ./src/graphql/api.js